type FormatOptions = {
  locale?: string;
  fallback?: string;
};

export const formatNumber = (
  value: unknown,
  options: FormatOptions = {},
): string => {
  const { locale = "en-IN", fallback = "0" } = options;

  if (typeof value !== "number" || !Number.isFinite(value)) {
    return fallback;
  }

  return new Intl.NumberFormat(locale).format(value);
};
